<template>
  <div class="brand-ad-bottm-logo">
    <div class="bottom-logo"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.brand-ad-bottm-logo {
  margin: 40px auto;
  width: 220px;
  height: 80px;
  overflow: hidden;
  .bottom-logo {
    width: 220px;
    height: 80px;
    background: url('../assets/image/bottom-logo.png');
    background-size: cover;
  }
}
</style>
